import { Box, List, Typography } from "@mui/material"
import { If } from "lib/@components/if"
import { Repeat } from "lib/@components/repeat"
import { ChangeSourceCitationListItem } from "./change-source-citation-list-item"

export function ChangeSourceCitationList({ citations }) {
    return (
        <If truthy={citations?.length}>
            <Box>
                <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
                    Referenced sources
                </Typography>
                <List dense disablePadding>
                    <Repeat list={citations} item={<ChangeSourceCitationListItem />} keyFn={keyByCitation} />
                </List>
            </Box>
        </If>
    )
}

function keyByCitation(item) {
    return item.key ?? `${item.sourceType}:${item.sourceDocumentId}:${item.findingTitle}`
}
